import { UseQueryResult } from '@tanstack/react-query';

import { RQAPICallWithData } from 'store/APIClient';
import { BudgetProposalWithResourcesT } from 'routes/BudgetModule/config/types';
import { budgetProposalsPostProcessingMiddleware } from 'routes/BudgetModule/helpers/budgetProposalsMiddlewares';
import { createBudgetQueryKeys } from 'routes/BudgetModule/helpers/createBudgetQueryKeys';
import { useBudgetProposalsQuery } from 'routes/BudgetModule/helpers/hooks/useCustomQuery';
import { BudgetT } from 'routes/BudgetModule/config/types';
import { useBudgetQuery } from 'routes/BudgetModule/helpers/hooks/useCustomQuery';
import { HttpError } from 'store/APIClient';

export const useGetBudgetProposalsWithResources = (): UseQueryResult<
    BudgetProposalWithResourcesT[]
> => {
    const { budgetProposalsKeys } = createBudgetQueryKeys();
    return useBudgetProposalsQuery(
        budgetProposalsKeys({ withResources: true }),
        async () => {
            const response = await RQAPICallWithData<
                BudgetProposalWithResourcesT[]
            >({
                endpoint: 'budget_proposals/with_resources',
                method: 'GET',
                postProcessingCallback: budgetProposalsPostProcessingMiddleware,
            });

            return response.content.data;
        },
    );
};

/**
 * A custom hook to fetch the list of budgets.
 */
export const useGetBudgets = (): UseQueryResult<BudgetT[], HttpError> => {
    const { budgetKeys } = createBudgetQueryKeys();
    return useBudgetQuery(budgetKeys(), async () => {
        const response = await RQAPICallWithData<BudgetT[]>({
            endpoint: `budget/common/budgets`,
            method: 'GET',
        });

        return response.content.data;
    });
};
